import React, { useEffect, useState } from "react";
import Select from 'react-select';
import { styleSelect } from "../../../constants/customStyles";
import { useDispatch, useSelector } from "react-redux";
import { savePoliceReport } from "../../../actions/PoliceReportActions";
import Toast from "../../../components/Toast";
import { getAllPoliceStation } from "../../../actions/PoliceStationActions";
import { saveLpo } from "../../../actions/LpoActions";
import { saveDrivingLicense } from "../../../actions/DrivingLicenseActions";
import moment from "moment/moment";
import Dropzone, { useDropzone } from 'react-dropzone';
import { Swiper, SwiperSlide } from "swiper/react";
import { Grid, Scrollbar } from "swiper";
import { ThreeDots } from "react-loader-spinner";

function DocumentModal(props) {
    const dispatch = useDispatch();

    const { modalJobCardId, jobCard } = props;

    const [previewImagesPoliceReport, setPreviewImagesPoliceReport] = useState([]);
    const [previewImagesDrivingLicense, setPreviewImagesDrivingLicense] = useState([]);

    const [reportNo, setReportNo] = useState('');
    const [selectedPolice, setSelectedPolice] = useState('');
    const [police, setPolice] = useState('');
    const [location, setLocation] = useState('');
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [expiryDate, setExpiryDate] = useState('');
    const [licenseNo, setLicenseNo] = useState('');
    const [name, setName] = useState('');

    const LicenseSave = () => {
        if (!expiryDate) {
            Toast.fire({
                icon: 'error',
                title: 'Expiry Date is Required!'
            })
        } else if (!licenseNo) {
            Toast.fire({
                icon: 'error',
                title: 'License No. is Required!'
            })
        } else if (!name) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else {
            let data = {
                expiry_date: expiryDate,
                license_no: licenseNo,
                name: name,
                imageId: removeImageDrivingLicense,
                job_card_id: jobCard?.job_card_id
            }
            let formData1 = new FormData();
            formData1.append('data', JSON.stringify(data));
            for (var key in drivingLicenseFiles) {
                formData1.append('images[]', drivingLicenseFiles[key])
            }
            dispatch(saveDrivingLicense(formData1));
        }
    }
    const insuranceTypes = useSelector(state => state?.insuranceType?.insuranceTypes?.data);
    const policeStations = useSelector(state => state?.police?.allPolice?.data);
    const loading = useSelector(state => state?.loading?.addEditLoading);

    const policeReportsave = () => {
        if (!reportNo) {
            Toast.fire({
                icon: 'error',
                title: 'Report Number is Required!'
            })
        } else if (!police.police_id) {
            Toast.fire({
                icon: 'error',
                title: 'Police is Required!'
            })
        } else if (!location) {
            Toast.fire({
                icon: 'error',
                title: 'Location is Required!'
            })
        } else if (!date) {
            Toast.fire({
                icon: 'error',
                title: 'Date is Required!'
            })
        } else if (!time) {
            Toast.fire({
                icon: 'error',
                title: 'Time is Required!'
            })
        } else {
            let data = {
                report_no: reportNo,
                police_id: police.police_id,
                location: location,
                date: date,
                time: time,
                imageId: removeImagePolice,
                job_card_id: jobCard?.job_card_id
            }
            let formData1 = new FormData();
            formData1.append('data', JSON.stringify(data));
            for (var key in policeReportFiles) {
                formData1.append('images[]', policeReportFiles[key])
            }
            dispatch(savePoliceReport(formData1));
        }
    }
    const [claimNo, setClaimNo] = useState('');
    const [lpoDate, setLpoDate] = useState('');
    const [value, setValue] = useState();
    const [excess, setExcess] = useState('');
    const [rebate, setRebate] = useState('');
    const [policyNo, setPolicyNo] = useState('');
    const [type, setType] = useState('');
    const [miscValue, setMiscValue] = useState('');
    const [parts, setParts] = useState('');
    const [repairs, setRepairs] = useState('');
    const [comission, setComission] = useState('');
    const [towing, setTowing] = useState('');
    const [vat, setVat] = useState('');
    const [excessVat, setExcessVat] = useState('');
    const [partsCost, setPartsCost] = useState('');
    const [repairsCost, setRepairsCost] = useState('');
    const [adjustments, setAdjustments] = useState('');
    const [lpoApproved, setLpoApproved] = useState('');
    const [selectedType, setSelectedType] = useState('');

    const handleChangeValue = (e) => {
        setValue(e.target.value)
        const Vat = e.target.value * 5 / 100;
        if (excessVat !== null) {
            setVat(Vat - excessVat)
        } else {
            setVat(Vat)
        }
    }

    const handleChangeLpoCalculation = (e) => {
        let amount = e.target.value;

        const calculatedAmount = value - amount;

        const Vat = amount * 5 / 100;
        const calculatedVat = calculatedAmount * 5 / 100;

        setVat(calculatedVat)
        setExcess(amount)
        setExcessVat(Vat)
    }

    const save = () => {
        if (!claimNo) {
            Toast.fire({
                icon: 'error',
                title: 'Claim Number is Required!'
            })
        } else if (!value) {
            Toast.fire({
                icon: 'error',
                title: 'Value is Required!'
            })
        } else if (!excess) {
            Toast.fire({
                icon: 'error',
                title: 'Excess is Required!'
            })
        } else if (!lpoDate) {
            Toast.fire({
                icon: 'error',
                title: 'Date is Required!'
            })
        } else if (!rebate) {
            Toast.fire({
                icon: 'error',
                title: 'Rebate is Required!'
            })
        } else {
            let data = {
                lpo_no: claimNo,
                lpo_value: value,
                // lpo_approved: lpoApproved,
                excess: excess,
                rebate: rebate,
                date: lpoDate,
                policy_no: policyNo,
                misc_value: miscValue,
                lpo_type: type,
                parts: parts,
                repairs: repairs,
                commission: comission,
                towing: towing,
                vat: vat,
                excess_vat: excessVat,
                parts_cost: partsCost,
                repair_cost: repairsCost,
                adjustment: adjustments,
                job_card_id: jobCard?.job_card_id,
            }
            dispatch(saveLpo(data));
        }
    }
    const handleChangeType = (e) => {
        setType(e.label)
        setSelectedType({
            label: e.label,
            value: e.value
        })
    }

    useEffect(() => {
        if (jobCard && Object.keys(jobCard).length > 0) {
            setPolice({ police_id: jobCard?.police_report?.police_id })
            setSelectedPolice(jobCard?.police_report?.police_id ? { id: jobCard?.police_report?.police_id, name: jobCard?.police_report?.police_station?.name } : jobCard?.police_report?.police_id)
            setReportNo(jobCard?.police_report_id);
            setLocation(jobCard?.police_report?.location);
            setDate(moment(jobCard?.police_report?.date).format('YYYY-MM-DD'));
            setTime(jobCard?.police_report?.time);
            setLicenseNo(jobCard?.driving_license?.license_no);
            setName(jobCard?.driving_license?.name);
            setLpoDate(moment(jobCard?.lpo_claim?.date).format('YYYY-MM-DD'));
            setClaimNo(jobCard?.lpo_claim?.lpo_no);
            setValue(jobCard?.lpo_claim?.lpo_value);
            setExcess(jobCard?.lpo_claim?.excess);
            setRebate(jobCard?.lpo_claim?.rebate);
            setPolicyNo(jobCard?.lpo_claim?.policy_no);
            if (jobCard?.lpo_claim?.lpo_type && jobCard?.lpo_claim?.lpo_type == 'Third Party') {
                setSelectedType({ value: 1, label: 'Third Party' })
            } else if (jobCard?.lpo_claim?.lpo_type && jobCard?.lpo_claim?.lpo_type == 'Unknown') {
                setSelectedType({ value: 2, label: 'Unknown' })
            } else {
                setSelectedType('')
            }
            setMiscValue(jobCard?.lpo_claim?.misc_value);
            setLpoApproved(jobCard?.lpo_claim?.lpo_approved)
            setParts(jobCard?.lpo_claim?.parts);
            setRepairs(jobCard?.lpo_claim?.repairs);
            setComission(jobCard?.lpo_claim?.commission);
            setTowing(jobCard?.lpo_claim?.towing);
            setVat(jobCard?.lpo_claim?.vat);
            setPartsCost(jobCard?.lpo_claim?.parts_cost);
            setRepairsCost(jobCard?.lpo_claim?.repair_cost);
            setAdjustments(jobCard?.lpo_claim?.adjustment);
        }
    }, [jobCard])

    const handleChangePolice = (event) => {
        // 'event', event)
        setPolice({
            police_id: event.police_station_id,
            name: event.name,
        });
        setSelectedPolice({
            police_id: event.police_station_id,
            name: event.name,
        });
    };

    useEffect(() => {
        if (jobCard?.police_report && Object.keys(jobCard?.police_report?.images).length > 0) {
            let preloadImages = [];
            jobCard?.police_report?.images.forEach(function (image, index) {
                preloadImages.push({ preview: image.image_path + '/' + image.file_name, default: 0, id: image.police_report_image_id });
            })
            setPoliceReportFiles(preloadImages);
            setPreviewImagesPoliceReport(preloadImages);
        }
    }, [jobCard?.police_report?.images])

    useEffect(() => {
        if (jobCard?.driving_license && Object.keys(jobCard?.driving_license?.images).length > 0) {
            let preloadImages = [];
            jobCard?.driving_license?.images.forEach(function (image, index) {
                preloadImages.push({ preview: image.image_path + '/' + image.file_name, default: 0, id: image.driving_license_image_id });
            })
            setDrivingLicenseFiles(preloadImages);
            setPreviewImagesDrivingLicense(preloadImages);
        }
    }, [jobCard?.driving_license?.images])

    const [policeReportFiles, setPoliceReportFiles] = useState([]);
    const [removeImagePolice, setRemoveImagePolice] = useState([]);
    const [drivingLicenseFiles, setDrivingLicenseFiles] = useState([]);
    const [removeImageDrivingLicense, setRemoveImageDrivingLicense] = useState([]);

    const thumbsContainer = {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        margin: 16
    };

    const thumb = {
        display: 'inline-flex',
        borderRadius: 2,
        border: '1px solid #eaeaea',
        marginBottom: 8,
        marginRight: 15,
        width: 100,
        height: 100,
        padding: 4,
        boxSizing: 'border-box'
    };

    const thumbInner = {
        display: 'block',
        minWidth: 92,
        overflow: 'hidden'
    };

    const img = {
        display: 'block',
        width: 'auto',
        height: '100%'
    };

    const { getRootProps: getRootPropsPoliceReport, getInputProps: getInputPropsPoliceReport } = useDropzone({
        maxFiles: 30,
        accept: '.jpeg,.png,.jpg',
        maxSize: 5000000,
        onDropAccepted: acceptedFiles => {
            if (policeReportFiles && policeReportFiles.length == 1) {
                setPoliceReportFiles(policeReportFiles.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                    preview: URL.createObjectURL(file),
                    default: (index == 0) ? 1 : 0
                }))));
            } else {
                if (acceptedFiles.length + policeReportFiles.length > 30 || acceptedFiles.length + policeReportFiles.length > 30) {
                    Toast.fire({
                        icon: 'error',
                        title: 'Maximum 30 Images Allowed',
                    });
                } else {
                    setPoliceReportFiles(policeReportFiles.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                        preview: URL.createObjectURL(file),
                        default: 0
                    }))));
                }
            }
        },
        onDropRejected: rejectedFiles => {
            if (rejectedFiles.length > 0) {
                let error = 'There was an error';
                if (rejectedFiles[0].errors[0].code == 'file-invalid-type') {
                    error = 'File Format Not Supported';
                } else if (rejectedFiles[0].errors[0].code == 'file-too-large') {
                    error = 'Image Size greater than 5mb'
                } else if (rejectedFiles[0].errors[0].code == 'too-many-files') {
                    error = 'Maximum 30 Images Allowed';
                }
                // setDropzoneError(rejectedFiles[0].errors[0].message);
                Toast.fire({
                    icon: 'error',
                    title: error,
                });
            }
        }
    });
    const { getRootProps: getRootPropsDrivingLicense, getInputProps: getInputPropsDrivingLicense } = useDropzone({
        maxFiles: 30,
        accept: '.jpeg,.png,.jpg',
        maxSize: 5000000,
        onDropAccepted: acceptedFiles => {
            if (drivingLicenseFiles && drivingLicenseFiles.length == 1) {
                setDrivingLicenseFiles(drivingLicenseFiles.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                    preview: URL.createObjectURL(file),
                    default: (index == 0) ? 1 : 0
                }))));
            } else {
                if (acceptedFiles.length + drivingLicenseFiles.length > 30) {
                    Toast.fire({
                        icon: 'error',
                        title: 'Maximum 30 Images Allowed',
                    });
                } else {
                    setDrivingLicenseFiles(drivingLicenseFiles.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                        preview: URL.createObjectURL(file),
                        default: 0
                    }))));
                }
            }
        },
        onDropRejected: rejectedFiles => {
            if (rejectedFiles.length > 0) {
                let error = 'There was an error';
                if (rejectedFiles[0].errors[0].code == 'file-invalid-type') {
                    error = 'File Format Not Supported';
                } else if (rejectedFiles[0].errors[0].code == 'file-too-large') {
                    error = 'Image Size greater than 5mb'
                } else if (rejectedFiles[0].errors[0].code == 'too-many-files') {
                    error = 'Maximum 30 Images Allowed';
                }
                // setDropzoneError(rejectedFiles[0].errors[0].message);
                Toast.fire({
                    icon: 'error',
                    title: error,
                });
            }
        }
    });
    const removeImage = (file, index, type) => {
        if (type = 'policeReport') {
            const updatedFiles = [...policeReportFiles];

            if (index === 0 && file.default === 1) {
                updatedFiles[1].default = 1;
            } else if (index !== 0 && file.default === 1) {
                updatedFiles[0].default = 1;
            }
            let imageIds = [];

            if (updatedFiles[index].id) {

                imageIds = updatedFiles[index].id;
                setRemoveImagePolice([
                    ...removeImagePolice,
                    imageIds
                ]);

            }

            updatedFiles.splice(index, 1);

            setPoliceReportFiles(updatedFiles);
        } else if (type = 'drivingLicense') {
            const updatedFiles = [...drivingLicenseFiles];

            if (index === 0 && file.default === 1) {
                updatedFiles[1].default = 1;
            } else if (index !== 0 && file.default === 1) {
                updatedFiles[0].default = 1;
            }
            let imageIds = [];

            if (updatedFiles[index].id) {

                imageIds = updatedFiles[index].id;
                setRemoveImageDrivingLicense([
                    ...removeImageDrivingLicense,
                    imageIds
                ]);

            }

            updatedFiles.splice(index, 1);

            setDrivingLicenseFiles(updatedFiles);
        }
    }

    const [dropzoneTitle, setDropZoneTitle] = useState("Please Upload Photos");
    const policeReportThumbs = policeReportFiles.length > 0 && policeReportFiles.map((file, index) => {
        return (
            <React.Fragment key={index + 1}>
                <SwiperSlide>
                    <div>
                        <div style={thumb} className={`${file.default == 1 ? "default-image" : ''}`} key={file.name}>
                            <div style={thumbInner}>
                                <img
                                    src={file.preview}
                                    style={img}
                                />
                            </div>
                        </div>
                        <span class="image-close" onClick={() => removeImage(file, index, 'policeReport')}>&times;</span>
                    </div>
                </SwiperSlide>
            </React.Fragment>
        )
    }
    );
    const drivingLicenseThumbs = drivingLicenseFiles.length > 0 && drivingLicenseFiles.map((file, index) => {
        return (
            <React.Fragment key={index + 1}>
                <SwiperSlide>
                    <div>
                        <div style={thumb} className={`${file.default == 1 ? "default-image" : ''}`} key={file.name}>
                            <div style={thumbInner}>
                                <img
                                    src={file.preview}
                                    style={img}
                                />
                            </div>
                        </div>
                        <span class="image-close" onClick={() => removeImage(file, index, 'drivingLicense')}>&times;</span>
                    </div>
                </SwiperSlide>
            </React.Fragment>
        )
    }
    );
    return (
        <React.Fragment>
            {/* Edit Police Report Modal */}
            <div id="document-modal" className="modal fade" tabindex="-1" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        {/* <!-- BEGIN: Modal Header --> */}
                        <div className="modal-header">
                            <h2 className="fw-medium fs-base me-auto">Documents</h2>
                        </div>
                        {/* </div> <!-- END: Modal Header --> */}
                        {/* <!-- BEGIN: Modal Body --> */}
                        <div className="modal-body">
                            {
                                loading ?
                                    <ThreeDots
                                        height="80"
                                        width="80"
                                        radius="9"
                                        color="#2d3748"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                        wrapperClassName=""
                                        visible={loading}
                                    /> :
                                    <span>
                                        <div className="grid columns-12">
                                            <div className="g-col-12 g-col-sm-2">
                                                <div class="">
                                                    <ul class="chat__tabs nav nav-pills rounded-2 flex-column"
                                                        role="tablist">
                                                        <li id="policeReport-tab"
                                                            class="nav-item flex-1 m-2"
                                                            role="presentation">
                                                            <button
                                                                class="nav-link w-full my-2 pt-2 active fs-base text-start br-right-radius me-4 pb-2.5"
                                                                data-bs-toggle="pill"
                                                                data-bs-target="#policeReport"
                                                                type="button" role="tab"
                                                                aria-controls="policeReport-tab"
                                                                aria-selected="false">Police Report</button>
                                                        </li>
                                                        <li id="license-tab"
                                                            class="nav-item flex-1 m-2"
                                                            role="presentation">
                                                            <button
                                                                class="nav-link w-full my-2 pt-2 fs-base text-start br-right-radius me-4 pb-2.5"
                                                                data-bs-toggle="pill"
                                                                data-bs-target="#license"
                                                                type="button" role="tab"
                                                                aria-controls="license-tab"
                                                                aria-selected="false">Driving License</button>
                                                        </li>
                                                        <li id="lpo-tab"
                                                            class="nav-item flex-1 m-2"
                                                            role="presentation">
                                                            <button
                                                                class="nav-link w-full my-2 pt-2 fs-base text-start br-right-radius me-4 pb-2.5"
                                                                data-bs-toggle="pill"
                                                                data-bs-target="#lpo"
                                                                type="button" role="tab"
                                                                aria-controls="lpo-tab"
                                                                aria-selected="false">LPO Claim</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="g-col-12 g-col-sm-10">
                                                <div class="tab-content">
                                                    <div class="tab-pane fade show active"
                                                        id="policeReport" role="tabpanel"
                                                        aria-labelledby="policeReport-tab">
                                                        <h2 className="fw-medium fs-base mb-2 me-auto">Police Report</h2>
                                                        <div className="grid columns-12">
                                                            <div className="intro-y g-col-6">
                                                                <label for="report_no" className="form-label">Report No. :</label>
                                                                <input id="report_no" value={reportNo} onChange={(e) => setReportNo(e.target.value)} name="report_no" type="text" required className="form-control" placeholder="Enter Report No." />
                                                            </div>
                                                            <div className="intro-y g-col-6">
                                                                <label for="police" className="form-label">Police :</label>
                                                                <Select styles={styleSelect} value={selectedPolice} onChange={(e) => handleChangePolice(e)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.police_station_id}`} options={policeStations && policeStations.length > 0 ? policeStations : []} />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-12">
                                                                <label for="location" className="form-label">Location :</label>
                                                                <input id="location" value={location} name="location" onChange={(e) => setLocation(e.target.value)} type="text" required className="form-control" placeholder="Enter Location" />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                                <label for="date" className="form-label">Date :</label>
                                                                <input id="date" name="date" value={date} onChange={(e) => setDate(e.target.value)} type="date" className="form-control" placeholder="Enter Date" />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                                <label for="time" className="form-label">Time :</label>
                                                                <input id="time" onChange={(e) => setTime(e.target.value)} name="time" value={time} type="time" className="form-control " placeholder="Enter Time" />
                                                            </div>
                                                            <div className="intro-y g-col-12">
                                                                <label for="image" className="form-label">Image:</label>
                                                                <section className="text-center form-control w-full">
                                                                    <aside style={thumbsContainer} className="justify-content-center mb-0">
                                                                        {
                                                                            (policeReportFiles.length == 0) &&
                                                                            <p className="dropz-title fs-base text-gray-500">Please upload Images</p>
                                                                        }
                                                                    </aside>
                                                                    <Swiper
                                                                        slidesPerView={5}
                                                                        scrollbar={{
                                                                            hide: true,
                                                                        }}
                                                                        grid={{
                                                                            rows: 1,
                                                                        }}
                                                                        modules={[Grid, Scrollbar]}
                                                                        className="mySwiper h-full"
                                                                    >
                                                                        {policeReportThumbs}
                                                                    </Swiper>
                                                                    <div {...getRootPropsPoliceReport({
                                                                        className: 'dropzone p-3'
                                                                    })}>
                                                                        <input {...getInputPropsPoliceReport()} />
                                                                        <hr className="border border-gray-200 bg-gray-300 border-dashed" />
                                                                        <div className="btn btn-primary w-25 mt-5">Upload Photos</div>
                                                                    </div>
                                                                </section>
                                                            </div>
                                                        </div>
                                                        <div className="text-end mt-5">
                                                            <button type="button" data-bs-dismiss="modal" className="btn btn-outline-secondary w-20 me-1">Cancel</button>
                                                            <button onClick={policeReportsave} type="button" className="btn btn-primary w-20">Submit</button>
                                                        </div>
                                                    </div>
                                                    <div class="tab-pane fade"
                                                        id="license" role="tabpanel"
                                                        aria-labelledby="license-tab">
                                                        <h2 className="fw-medium fs-base mb-2 me-auto">Driving License</h2>
                                                        <div className="grid columns-12">
                                                            <div className="intro-y g-col-6">
                                                                <label for="expiry_date" className="form-label">Expiry Date :</label>
                                                                <div className="input-group mx-auto ">
                                                                    <div id="input-group-email" className="input-group-text "> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-calendar w-4 h-4"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> </div> <input type="date" placeholder="Enter Expiry Date" value={moment(jobCard?.driving_license?.expiry_date).format('YYYY-MM-DD')} onChange={(e) => setExpiryDate(e.target.value)} id="expiry_date" name="expiry_date" className="datepicker form-control " data-single-mode="true" />
                                                                </div>
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                                <label for="licence_no" className="form-label"> Licence No. :</label>
                                                                <input id="licence_no" value={licenseNo} onChange={(e) => setLicenseNo(e.target.value)} name="licence_no" type="text" className="form-control" placeholder="Enter Licence No" />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-12">
                                                                <label for="name" className="form-label">Name :</label>
                                                                <input id="name" value={name} onChange={(e) => setName(e.target.value)} name="name" type="text" required className="form-control" placeholder="Enter Name" />
                                                            </div>
                                                            <div className="intro-y g-col-12">
                                                                <label for="image" className="form-label">Image:</label>
                                                                <section className="text-center form-control w-full">
                                                                    <aside style={thumbsContainer} className="justify-content-center mb-0">
                                                                        {
                                                                            (drivingLicenseFiles.length == 0) &&
                                                                            <p className="dropz-title fs-base text-gray-500">Please upload Images</p>
                                                                        }
                                                                    </aside>
                                                                    <Swiper
                                                                        slidesPerView={5}
                                                                        scrollbar={{
                                                                            hide: true,
                                                                        }}
                                                                        grid={{
                                                                            rows: 1,
                                                                        }}
                                                                        modules={[Grid, Scrollbar]}
                                                                        className="mySwiper h-full"
                                                                    >
                                                                        {drivingLicenseThumbs}
                                                                    </Swiper>
                                                                    <div {...getRootPropsDrivingLicense({ className: 'dropzone p-3' })}>
                                                                        <input {...getInputPropsDrivingLicense()} />
                                                                        <hr className="border border-gray-200 bg-gray-300 border-dashed" />
                                                                        <div className="btn btn-primary w-25 mt-5">Upload Photos</div>
                                                                    </div>
                                                                </section>
                                                            </div>
                                                        </div>
                                                        <div className="text-end mt-5">
                                                            <button type="button" data-bs-dismiss="modal" className="btn btn-outline-secondary w-20 me-1">Cancel</button>
                                                            <button onClick={LicenseSave} type="button" className="btn btn-primary w-20">Submit</button>
                                                        </div>
                                                    </div>
                                                    <div class="tab-pane fade"
                                                        id="lpo" role="tabpanel"
                                                        aria-labelledby="lpo-tab">
                                                        <h2 className="fw-medium fs-base mb-2 me-auto">LPO Claim</h2>
                                                        <div className="grid columns-12">
                                                            {/* <div className="intro-y g-col-6">
                                                <label for="lpo_id" className="form-label"> LPO ID :</label>
                                                <input id="lpo_id" name="lpo_id" type="text" required className="form-control" placeholder="Enter LPO ID" />
                                            </div> */}
                                                            <div className="intro-y g-col-12 g-col-sm-4">
                                                                <label for="date" className="form-label">Date :</label>
                                                                <div className="input-group mx-auto ">
                                                                    <div id="input-group-email" className="input-group-text "> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-calendar w-4 h-4"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> </div> <input type="date" value={lpoDate} placeholder="Enter Date" onChange={(e) => setLpoDate(e.target.value)} id="date" name="lpoDate" className="datepicker form-control " data-single-mode="true" />
                                                                </div>
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-4">
                                                                <label for="claim_no" className="form-label">Claim No. :</label>
                                                                <input id="claim_no" value={claimNo} onChange={(e) => setClaimNo(e.target.value)} name="claim_no" type="text" required className="form-control" placeholder="Enter Claim No." />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-4">
                                                                <label for="value" className="form-label"> Value<span className="text-theme-6">*</span> :</label>
                                                                <input id="value" value={value} onChange={(e) => handleChangeValue(e)} name="value" type="text" className="form-control" placeholder="Enter Value" />
                                                            </div>
                                                            {/* <div className="intro-y g-col-12 g-col-sm-4">
                                                                                <label for="lpoApproved" className="form-label">LPO Amount Approved<span className="text-theme-6">*</span> :</label>
                                                                                <input id="lpoApproved" value={lpoApproved} name="lpoApproved" type="text" required className="form-control" onChange={(e) => handleChangeLpoCalculation(e)} placeholder="Enter LPO Amount Approved" />
                                                                            </div> */}
                                                            <div className="intro-y g-col-12 g-col-sm-4">
                                                                <label for="excess" className="form-label">Excess :</label>
                                                                <input id="excess" value={excess} onChange={(e) => handleChangeLpoCalculation(e)} name="excess" type="text" required className="form-control" placeholder="Enter Excess" />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-4">
                                                                <label for="rebate" className="form-label">Rebate (%) :</label>
                                                                <input id="rebate" name="rebate" value={rebate} onChange={(e) => setRebate(e.target.value)} type="text" required className="form-control" placeholder="Enter Rebate" />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-4">
                                                                <label for="policy_no" className="form-label">Policy No. :</label>
                                                                <input id="policy_no" value={policyNo} onChange={(e) => setPolicyNo(e.target.value)} name="policy_no" type="text" required className="form-control" placeholder="Enter Policy No." />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-4">
                                                                <label for="type" className="form-label">Type :</label>
                                                                <Select styles={styleSelect} value={selectedType} onChange={(e) => handleChangeType(e)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.name}`} options={insuranceTypes && insuranceTypes.length > 0 ? insuranceTypes : []} />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-4">
                                                                <label for="misc_value" className="form-label">Misc Value :</label>
                                                                <input id="misc_value" value={miscValue} name="misc_value" onChange={(e) => setMiscValue(e.target.value)} type="text" required className="form-control" placeholder="Enter Misc Value" />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-4">
                                                                <label for="parts" className="form-label">Parts :</label>
                                                                <input id="parts" name="parts" value={parts} onChange={(e) => setParts(e.target.value)} type="text" required className="form-control" placeholder="Enter Parts" />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-4">
                                                                <label for="repairs" className="form-label">Repairs :</label>
                                                                <input id="repairs" name="repairs" value={repairs} onChange={(e) => setRepairs(e.target.value)} type="text" required className="form-control" placeholder="Enter Repairs" />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-4">
                                                                <label for="comission" className="form-label">Comission :</label>
                                                                <input id="comission" name="comission" value={comission} onChange={(e) => setComission(e.target.value)} type="text" required className="form-control" placeholder="Enter Comission" />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-4">
                                                                <label for="towing" className="form-label">Towing :</label>
                                                                <input id="towing" name="towing" type="text" value={towing} onChange={(e) => setTowing(e.target.value)} required className="form-control" placeholder="Enter Towing" />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-4">
                                                                <label for="vat" className="form-label">VAT :</label>
                                                                <input id="vat" name="vat" disabled value={vat} onChange={(e) => setVat(e.target.value)} type="text" required className="form-control" placeholder="Enter VAT" />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-4">
                                                                <label for="vat" className="form-label">Excess VAT :</label>
                                                                <input id="vat" name="vat" disabled value={excessVat} onChange={(e) => setExcessVat(e.target.value)} type="text" required className="form-control" placeholder="Enter Excess VAT" />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-4">
                                                                <label for="parts_cost" className="form-label">Parts Cost :</label>
                                                                <input id="parts_cost" value={partsCost} name="parts_cost" onChange={(e) => setPartsCost(e.target.value)} type="text" required className="form-control" placeholder="Enter Parts Cost" />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-4">
                                                                <label for="repair_cost" className="form-label">Repair Cost :</label>
                                                                <input id="repair_cost" value={repairsCost} name="repair_cost" type="text" onChange={(e) => setRepairsCost(e.target.value)} required className="form-control" placeholder="Enter Repair Cost" />
                                                            </div>
                                                            <div className="intro-y g-col-12 g-col-sm-4">
                                                                <label for="adjustment" className="form-label">Adjustments :</label>
                                                                <input id="adjustment" value={adjustments} name="adjustment" type="text" onChange={(e) => setAdjustments(e.target.value)} required className="form-control" placeholder="Enter Adjustments" />
                                                            </div>
                                                        </div>
                                                        <div className="text-end mt-5">
                                                            <button type="button" data-bs-dismiss="modal" className="btn btn-outline-secondary w-20 me-1">Cancel</button>
                                                            <button onClick={save} type="button" disabled={loading ? true : false} className="btn btn-primary w-20">Submit</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <!-- END: Modal Body --> */}
                                        {/* <!-- BEGIN: Modal Footer --> */}
                                    </span>
                            }
                        </div>
                    </div>
                </div >
            </div >
            {/*End Edit Police Report Modal */}
        </React.Fragment >
    )
}

export default DocumentModal;
